import bfTabsItem from './bf-tabs-item.vue';
bfTabsItem.install = Vue => Vue.component(bfTabsItem.name,bfTabsItem);
export default bfTabsItem;



// WEBPACK FOOTER //
// ./src/packages/tabs/bf-tabs-item/index.js